import $ from 'jquery';
import _ from 'lodash';
import {View} from 'backbone';
import { Model } from 'backbone';
import eventBus  from 'EventBus.js';
import _template from 'dashboard/forms/form-main.ejs';
import constants from 'Constants.js';
import textConstants from 'TextConstants.js';
import RestService from 'RestService';
import UndoService from 'UndoService';
import SelectItemModalView  from 'common-views/SelectItemModalView.js';
import notificationService  from 'NotificationService.js';
import util from 'util/Util.js';

class FormMainView extends View {

    className(){
        return 'FormMainView';
    }

    initialize(opts) {
        this.options = opts || {};
        this.template = _template;
        this.favoriteSelected = null;
        this.bounceDelay = 500;

        this.events = {
            'click #recentEdits > ul > li' : 'showFormDetails',
            'click #favoriteForms > ul > li' : 'selectFavoriteForm',
            'dblclick #favoriteForms > ul > li' : 'showFormDetails',
            'click #add' : 'addFavorites',
            'click #remove' : 'removeFavorites',
            'click #ddFrmMainInstances > li' : 'showInstance',
            'click #lstFrmMainInstances span.detFormInstance' : 'loadViewByInstance',
            'click .listSelected > ul > li' : 'showFormInfo' 
        };

        util.setDashboardFormsListCache();

        return this;
    }

    addFavorites(ev){
        ev.preventDefault();
        const _cachedItems = util.getDashboardFormsListCache();
        if (!_cachedItems) {
            let _self = this;
            RestService.searchFormByName('', true).then((results) => {

                let group = results.RESULT.RESPONSE.Group;
                let _items = [];

                if (group && group.Item) {
                    _items = group.Item instanceof Array ?
                    group.Item : [group.Item];
                }

                let items = _items.map((item) => {
                    return {
                        label: item['@name'],
                        listType: item['@id'],
                        items: item
                    }
                });

                util.setDashboardFormsListCache(items);
                _self.fillFavoritesModal(items);                
            });
        }else{
            this.fillFavoritesModal(_cachedItems);
        }
    }

    fillFavoritesModal(items){
        let formsView = new SelectItemModalView({ model: new Model({ items: items, multipleSelectionEnabled: true }) });
        formsView.render().then(selectedItem => {
            let oldFavoriteItems = Object.assign([],this.model.get('currentFavoritesList'));

            if (selectedItem) {
                let _selectedItems = [];
                if (!$.isArray(selectedItem)) { //If more than one item is selected then will return an array
                    _selectedItems.push(selectedItem);
                } else {
                    _selectedItems = selectedItem;
                }

                let _self = this;
                let _params = { formIds: [] };
                let currentFavoritesList = _self.model.get('currentFavoritesList') || [];
                let formsChanged = [];

                $.each(_selectedItems, function (index, _selectedItem) {
                    // Checking if the item selected is not already present in the current list.                       
                    if (currentFavoritesList) {
                        let formChanged = currentFavoritesList.filter((form) => {
                            return form['@id'] === _selectedItem.items['@id'];
                        });

                        if (formChanged.length) {
                            formsChanged.push(formChanged);
                        }
                        else {
                            currentFavoritesList.push(_selectedItem.items);
                            _params.formIds.push(_selectedItem.items['@id']);

                            _self.model.set('hasChanges', true, { silent: true });
                        }
                    }
                });

                currentFavoritesList.sort(function (a, b) {
                    var aName = a['@name'].toLowerCase();
                    var bName = b['@name'].toLowerCase();
                    return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
                });

                _self.model.set('currentFavoritesList', currentFavoritesList, { silent: true });

                if (_params.formIds.length) {
                    RestService.
                        addFavorites(_params, 1)
                        .then(result => {
                            _self.render();
                        });
                    UndoService.add({
                        undo:() => {

                            let _paramsUndo = Object.assign([],_params.formIds.split(','));
                            _self.model.set('currentFavoritesList',oldFavoriteItems,{silent:true});
                            const functions = _paramsUndo.map(param => () => RestService.removeFavorites({formId:param},1));
                            util.promiseSerial(functions).then(()=>{
                                _self.render();
                            });
                        },
                        redo:() => {
                            let paramsRedo = Object.assign({},_params);
                            _self.model.set('currentFavoritesList',currentFavoritesList,{silent:true})
                            RestService.addFavorites(paramsRedo,1).then(result =>{
                                _self.render();
                            })
                        }
                    },textConstants.UNDO_FORM_FAVORITES)
                }
                else {
                    _self.render();
                }
            }
        }).catch((errMsg) => {
            console.log(errMsg);
            notificationService.error(errMsg);
        });
    }


    removeFavorites(ev) {
        ev.preventDefault();        

        let currentFavoritesList = this.model.get('currentFavoritesList');
        if (this.favoriteSelected && currentFavoritesList && currentFavoritesList.length > 0) {
            let _params = {
                formId: this.favoriteSelected
            }

            let _self = this;

            RestService
                .removeFavorites(_params, 1)
                .then(result => {
                    let selectedElementIdx = 0;
                    let nextElementIdx = 0;

                    $.each(currentFavoritesList, (idx, item) => {
                        if (item['@id'] === _self.favoriteSelected) {
                            selectedElementIdx = idx;
                            return;
                        }
                    });

                    if (selectedElementIdx === currentFavoritesList.length - 1) {
                        nextElementIdx = selectedElementIdx - 1;
                    } else {
                        nextElementIdx = selectedElementIdx;
                    }

                    currentFavoritesList = currentFavoritesList.filter(f => f['@id'] !== _self.favoriteSelected);                    
                    _self.model.set('currentFavoritesList', currentFavoritesList, { silent: true });
                    
                    if (nextElementIdx >= 0) {
                        let _scrollTop = $("#favoriteForms").parent().scrollTop();
                        _self.favoriteSelected = currentFavoritesList[nextElementIdx]['@id'];
                        _self.render();

                        let nextElement = $('#favoriteForms ul li')[nextElementIdx];
                        $(nextElement).addClass('dashboard-favorited-item');                        
                        $("#favoriteForms").parent().scrollTop(_scrollTop);
                    }else{
                        _self.favoriteSelected = null;
                        _self.render();                        
                        $('#remove').prop('disabled', false);
                    }                    
            }).catch(result => {
                $('#remove').prop('disabled', false);
            });
        }        
    }

    selectFavoriteForm(ev) {
        ev.preventDefault();
        ev.stopPropagation();

        let favorited = $('.dashboard-favorited-item');
        if (favorited) {
            favorited.removeClass('dashboard-favorited-item')
        }

        $(ev.currentTarget).addClass('dashboard-favorited-item');

        const formId = ev.currentTarget.attributes["data-id"].value;
        this.favoriteSelected = formId; 
    }

    loadViewByInstance(ev){
        eventBus.trigger('loadViewByInstance', ev);
    }

    showInstance(ev) {
        const formId = ev.currentTarget.attributes["formid"].value;
        if(formId==='all'){
            eventBus.trigger('getAllFormInstance', ev);
        }else{
            eventBus.trigger('getFormInstance', formId, ev.currentTarget);
        }
    }

    showFormDetails(ev) {
        const formId = ev.currentTarget.attributes["data-id"].value;
        eventBus.trigger('newInstance', formId, constants.FORMS_PRIVATE_GROUP_TYPE, `${constants.FORMS_PRIVATE_GROUP_TYPE}-${formId}`);
    }

    showFormInfo(ev){
        const formId = ev.currentTarget.attributes["formId"].value;
        
        if( formId === 'none'){
            return;
        }

        $('ul.select-list li').removeClass('selected');
        $(ev.currentTarget).addClass('selected');
    }

    render() {
        this.$el.html(this.template(this.model.toJSON())); 
        this.delegateEvents();
        return this; 
    }

    refresh(){
        eventBus.trigger(constants.EV_REFRESH_FORMS_MAIN_VIEW_DETAILS);
    }
}

export default FormMainView;